<div class="hudevo__streamer">
    <div class="hudevo__streamer_image"></div>
    <div class="hudevo__notification_subtitle">zdobich</div>
</div>